<!-- <div v-for="(row, index) in indicatorsList" :key="`indicator-${index}`">
    {{ row.name }}
</div> -->
<template>
  <div class="leading-indicators-list">
    <!-- <p v-if="Object.keys(indicatorsList).length === 0">You do not have any indicator lists yet. </p> -->
    <div class="three-col-wrapper">
      <!-- <div class="justify-content-center"> -->

      <!-- <template  v-for="(row, index) in indicatorsList" :key="`indicator-${index}`"> -->
      <template v-if="jsonReady">
        <!-- <template v-if="list.first_report == null" >
                    {{hasXMLcontent(false, list.name, 'first_report')}}
                </template> -->
        <!-- <template v-else-if='list.first_report.xml_content_json == null'>
                    {{hasXMLcontent(false, list.name, 'xml_content_json')}}
                </template> -->

        <div
          class="col-inner"
          v-for="(list, index) in indicatorsList"
          :key="`indicator-${index}`"
        >
          <!-- <div class="col-inner"> -->
          <!-- {{ hasXMLcontent(true)}} -->
          <div class="article-card">
            <a class="article-main-link" :href="'/insider/' + list.url">
              <div
                id="indicatorlist-article-card--top"
                class="article-card--top"
              >
                <div class="article-card--image image-zoom">
                  <template v-if="list.image">
                    <img :src="'/storage/' + list.image" :alt="list.name" />
                  </template>
                </div>
              </div>
              <h3>{{ list.name }}</h3>
            </a>

            <div class="article-card--buttons">
              <template v-if="ismobiledevice">
                <a
                  :href="'/insider/' + list.url"
                  class="vue-anchor"
                  data-placement="top"
                  title="View Indicators"
                >
                  <span class="icon-view">
                    <span class="visually-hidden">View Indicators</span>
                  </span>
                </a>
              </template>
              <template v-else>
                <a
                  :href="'/insider/' + list.url"
                  class="vue-anchor"
                  data-placement="top"
                  title="View Indicators"
                >
                  <span class="button-green">View Indicators</span>
                </a>
                <!-- <a :href="'/insider/' + list.url"   class="vue-anchor" data-placement="top" title="View Indicators"><span class="icon-view"><span class="visually-hidden">View Indicators</span></span></a> -->
              </template>
            </div>
          </div>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
  export default {
    props: {
      indicatorsList: {
        type: Array,
        default: () => [],
      },
      imagespath: {
        type: String,
        required: false,
      },
    },
    data: function () {
      return {
        parsed: {},
        ismobiledevice: false,
        jsonReady: true,
        summary: '',
        images_path: this.imagespath,
      };
    },
    methods: {
      parseJson: function () {
        this.jsonReady = true;
      },
    },
  };
  //https://stackoverflow.com/questions/13869627/unable-to-access-json-property-with-dash  jsonObj.profile - id
  //To access a key that contains characters that cannot appear in an identifier, use brackets: jsonObj["profile-id"]
</script>
<style lang="scss" scoped>
  .three-col-wrapper {
    justify-content: center;
    .article-card {
      border: none;

      .article-main-link {
        h3 {
          color: $blue; //#17355C
        }
      }

      &:hover {
        #indicatorlist-article-card--top {
          background: transparent;
        }
      }
    }
    .article-card--buttons {
      a.vue-anchor {
        width: 173px;
      }
    }
  }
</style>
